export const timeFormat = 'H:mm';

export const dateFormat = 'dd. DD.MM.YY';

// export const apiServer = 'https://staging.mwd-agentur.de/ebb/web/';
export const apiServer = 'https://app.eisbaeren.de/';

// export const socketServer = 'https://ebb-socket-proxy.now.sh/';
export const socketServer = 'https://appticker.eisbaeren.de/';



// WEBPACK FOOTER //
// ./src/utils/variables.js